import { useCallback, useMemo } from 'react';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { ITaxForm, ITaxFormType } from '../TaxForms.types';

const NAME = 'tax-form-1099';

const useDownloadTaxFile = ({ id, name, type }: ITaxForm) => {
  const fileName = useMemo(() => {
    return name ? `${name}.pdf` : `${NAME}_${id}.pdf`;
  }, [id, name]);

  const handleGetFile = useCallback(async () => {
    const response = await api.get(
      type === ITaxFormType.TaxForm5498 
        ? API_URL.TAX_FORMS_TAX_FORM_5498_DOWNLOAD_BY_ID(id) 
        : API_URL.TAX_FORMS_TAX_FORM_1099_DOWNLOAD_BY_ID(id),
      {
        responseType: 'blob',
      }
    );

    const file = new File([response.data], fileName, { type: 'application/pdf' });

    const currentUrl = URL.createObjectURL(file);

    return currentUrl;
  }, [fileName, id, type]);
  const handleDownload = useCallback(async () => {
    const currentUrl = await handleGetFile();
    const a = document.createElement('a');
    a.href = currentUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }, [handleGetFile, fileName]);
  const handleOpenPreview = useCallback(async () => {
    const currentUrl = await handleGetFile();

    window.open(currentUrl);
  }, [handleGetFile]);
  return {
    handleDownload,
    handleOpenPreview,
  };
};
export default useDownloadTaxFile;
